//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { useEffect, useRef } from 'react';

/**
 * Store the previous value to be compared on subsequent renders
 *
 * @param value
 *
 * Inspired by https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 */
export function usePrevious<T>(value: T) {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}
